export default function getMessageOrigin(origin: string): string {
  // in some hybrid mobile frameworks the pages are served from
  // the device itself causing the origin to be file:// and the interstitial
  // to not open
  // more info: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#using_window.postmessage_in_extensions_non-standard
  const locationOrigin = window.location.origin === 'file://' ? '*' : origin
  return locationOrigin
}